/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PayWithCouponCoursePriceDataParser = 
/* #__PURE__ */ parsers.object([['code', codecString]]);
export class PayWithCouponCoursePriceData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PayWithCouponCoursePriceDataParser.decode(input).map(res => new PayWithCouponCoursePriceData(res));
    }
    static unsafeDecode(input) {
        return PayWithCouponCoursePriceData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PayWithCouponCoursePriceDataParser.encode(data);
    }
    static schema() {
        return PayWithCouponCoursePriceDataParser.schema();
    }
}
